import React from "react";
import "./About.css"

const About = () => {
  return (
    <div className="about-container" id="about">
      <div className="about-content">
        <h1>Welcome to Little Smiles</h1>
        <p>
          A Bangalore-based photography studio dedicated to turning life’s
          special moments into timeless memories. My journey into photography
          began in the most unexpected yet meaningful way—capturing the
          precious moments of my daughter’s life. Her laughter, curiosity, and
          innocence inspired me to transform my passion into an art form.
        </p>
        <p>
          Specializing in baby, family, and lifestyle photography, I bring a
          blend of technical precision and artistic creativity to every
          session. At Little Smiles, my goal is to craft warm, authentic, and
          heartfelt images that you and your loved ones will cherish for a
          lifetime—all at affordable prices, because everyone deserves
          beautiful memories.
        </p>
        <p>
          Let’s create something special together. Visit our Bangalore studio
          or <strong>contact us today</strong> to book your session!
        </p>
      </div>
    </div>
  );
};

export default About;
